<template>
  <vx-card title="Финансовая аналитика" class="vx-card_full-height">
    <template #actions>
      <vs-button
        v-if="$can('support', 'write')"
        @click="onRecalcFines"
        type="border"
        size="small"
      >
        Расчет Пеней
      </vs-button>
    </template>
    <div class="flex flex-col flex-1">
      <grid-infinite-scroll
        ref="table"
        :columns="columns"
        :getData="getData"
        :filterable="false"
        :sortable="false"
      />
    </div>
  </vx-card>
</template>

<script>
import AccountNumberRenderer from "@/components/employee/accounts/AccountNumberRenderer";

export default {
  name:     "FinancialAnalytics",
  data:     () => ({
    columns: [
      {
        headerName:            'Счет',
        field:                 'account_number',
        minWidth:              120,
        sortable:              true,
        filter:                true,
        pinned:                'left',
        cellRendererFramework: AccountNumberRenderer,
        cellRendererParams:    ( { data } ) => Object.assign({ routerName: 'uc_b_financial_analytics_account' }, data),
      },
      {
        headerName: 'Всего начислено',
        field:      'charges',
        filter:     'number',
      },
      {
        headerName: 'Всего оплачено',
        field:      'invoices',
        filter:     'number',
      },
      {
        headerName: 'Всего пеней',
        field:      'fine_sum',
        filter:     'number',
      },
      {
        headerName: 'Неоплаченных пеней',
        field:      'fine_debt',
        filter:     'number',
      },
      {
        headerName: 'Баланс',
        field:      'ballance',
        filter:     'number',
      },
    ],
  }),
  computed: {
    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },
  },
  methods:  {
    resetData() {
      this.$refs.table.resetData();
    },
    getData( page, filters, orderBy ) {
      return new Promise(async ( resolve ) => {
        let params = {
          orderby:      orderBy,
          filters:      filters,
          page:         page,
          buildings_id: this.selectedHouseId,
        };

        let { data } = await this.$http.get('building_summary', {
          params: params,
        });

        resolve({
          response: data,
          total:    data.total,
          data:     data.data,
        });
      });
    },

    onRecalcFines() {
      this.$modal.open({
        title:          'Расчет Пеней',
        size:           'sm',
        component:      () => import('@/components/calculated-program/financial-analytics/RecalcFinesModal'),
        componentProps: { buildingId: this.selectedHouseId },
      }).result.then(
        () => this.resetData(),
        () => {},
      );
    },
  },
  watch:    {
    selectedHouseId() {
      this.resetData();
    },
  },
};
</script>
